/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S4_Li2Inputs */

const en_guide_what_is_json_s4_li2 = /** @type {(inputs: Guide_What_Is_Json_S4_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Configuration Files</strong>: Tools like npm, TypeScript, ESLint, and VS Code use JSON for settings`)
};

const ko_guide_what_is_json_s4_li2 = /** @type {(inputs: Guide_What_Is_Json_S4_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>설정 파일</strong>: npm, TypeScript, ESLint, VS Code 같은 도구가 설정에 JSON을 사용합니다`)
};

const ja_guide_what_is_json_s4_li2 = /** @type {(inputs: Guide_What_Is_Json_S4_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>設定ファイル</strong>: npm、TypeScript、ESLint、VS Codeなどのツールは設定にJSONを使用します`)
};

/**
* | output |
* | --- |
* | "<strong>Configuration Files</strong>: Tools like npm, TypeScript, ESLint, and VS Code use JSON for settings" |
*
* @param {Guide_What_Is_Json_S4_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s4_li2 = /** @type {((inputs?: Guide_What_Is_Json_S4_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S4_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s4_li2(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s4_li2(inputs)
	return ja_guide_what_is_json_s4_li2(inputs)
});